import { Outlet, Link } from 'react-router-dom'
import Sidebar from './Sidebar'
import MobileNav from './MobileNav'
import RightPanel from './RightPanel'

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#0c0c0c] text-zinc-100 safe-area-top">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[120] focus:rounded-xl focus:bg-zinc-900 focus:px-4 focus:py-2 focus:text-white focus:ring-2 focus:ring-red-500/70 focus:ring-offset-2 focus:ring-offset-[#050505]"
      >
        Skip to main content
      </a>
      <div className="max-w-[1440px] mx-auto flex h-screen overflow-hidden relative">
        {/* Sidebar — sits on page background */}
        <Sidebar />

        {/* Floating content panel */}
        <div className="flex-1 min-w-0 flex md:py-2.5 md:pr-2.5">
            <div className="flex-1 min-w-0 flex bg-[#050505] md:rounded-2xl overflow-hidden border border-transparent md:border-zinc-800/40 glow-panel">
            <main id="main-content" tabIndex={-1} className="flex-1 min-w-0 h-screen overflow-y-auto custom-scrollbar">
              <Outlet />

              {/* Legal footer */}
              <footer className="border-t border-zinc-800/30 px-5 py-6 mt-8">
                <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-zinc-600">
                  <Link to="/terms" className="hover:text-zinc-400 transition-colors">Terms</Link>
                  <Link to="/privacy" className="hover:text-zinc-400 transition-colors">Privacy</Link>
                  <Link to="/2257" className="hover:text-zinc-400 transition-colors">2257 Compliance</Link>
                  <span className="ml-auto">&copy; {new Date().getFullYear()} Heatly</span>
                </div>
              </footer>
            </main>

            <RightPanel />
          </div>
        </div>
      </div>

      <MobileNav />

      {/* Spacer for mobile nav */}
      <div className="md:hidden h-20" />
    </div>
  )
}
